import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Email = () => {
  const stats = [
    { label: 'Sent', value: '124,500', change: '+12K', changeType: 'positive' },
    { label: 'Open Rate', value: '34.2%', change: '+2.4%', changeType: 'positive' },
    { label: 'Click Rate', value: '8.7%', change: '+1.1%', changeType: 'positive' },
    { label: 'Conversions', value: '892', change: '+67', changeType: 'positive' },
  ];

  const campaigns = [
    { name: 'Weekly Newsletter', sent: '45,000', openRate: '38%', status: 'Sent' },
    { name: 'Product Launch', sent: '32,000', openRate: '42%', status: 'Sent' },
    { name: 'Holiday Promo', sent: '0', openRate: '-', status: 'Scheduled' },
    { name: 'Re-engagement', sent: '0', openRate: '-', status: 'Draft' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Email Marketing</h1>
        <p className="lm-page-subtitle">Manage email campaigns and automation</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Email Campaigns</h3>
          <Button variant="primary" size="sm" icon="mail">New Campaign</Button>
        </div>
        <div className="lm-grid">
          {campaigns.map((campaign, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{campaign.name}</span>
                <span className="lm-grid-card-badge" style={{
                  background: campaign.status === 'Sent' ? 'var(--success-soft)' :
                             campaign.status === 'Scheduled' ? 'var(--primary-soft)' : 'var(--bg-tertiary)',
                  color: campaign.status === 'Sent' ? 'var(--success)' :
                         campaign.status === 'Scheduled' ? 'var(--primary)' : 'var(--text-tertiary)'
                }}>{campaign.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>Sent: {campaign.sent} • Open Rate: {campaign.openRate}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Email;
